import React from 'react';
import classes from './count-drag-preview.module.scss';

type CountDragPreviewProps = {
  count: number;
  text: string;
};

export const CountDragPreview: React.FC<CountDragPreviewProps> = ({ count, text }) => {
  return (
    <div className={classes.Container}>
      <div className={classes.Count}>{count}</div>
      <div className={classes.Text}>{text}</div>
    </div>
  );
};
